import React from 'react';
import {
  BarChart,
  PieChart,
  Bar,
  Pie,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell
} from 'recharts';
import './NuevoDashboard.css';

const COLORS = ['#28a745', '#3a2c91', '#6c757d', '#00D8FE', '#ffc107'];

const DashboardRecharts = ({ dataVentasDia, dataMediosPago }) => {
  // Verificar si hay datos y extraer el primer elemento del array
  const ventasData = dataVentasDia && dataVentasDia.length > 0 ? dataVentasDia[0] : null;
  const mediosPagoData = dataMediosPago && dataMediosPago.length > 0 ? dataMediosPago : [];
  
  // Preparar datos para el gráfico de documentos
  const salesData = ventasData ? [
    { 
      metodo: 'Boletas', 
      ventas: parseFloat(ventasData.Boletas || 0),
      cantidad: parseInt(ventasData.CantidadBoletas || 0)
    },
    { 
      metodo: 'Facturas', 
      ventas: parseFloat(ventasData.Facturas || 0),
      cantidad: parseInt(ventasData.CantidadFacturas || 0)
    },
    { 
      metodo: 'Vales', 
      ventas: parseFloat(ventasData.Vales || 0),
      cantidad: parseInt(ventasData.CantidadVales || 0)
    }
  ] : [];

  
  const methodSales = mediosPagoData.map(item => ({
    metodo: item.medio_pago,
    ventas: parseFloat(item.total_monto || 0),
    transacciones: parseInt(item.cantidad_transacciones || 0),
    promedio: parseFloat(item.monto_promedio || 0),
    porcentaje: parseFloat(item.porcentaje_participacion || 0),
    tipopago: item.id_tipo_pago,
    color: item.color_grafico,
    ranking: item.ranking_monto
  }));

  // Función para formatear currency de forma segura
  const formatCurrency = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? '0.00' : num.toFixed(2);
  };

  if (!ventasData && methodSales.length === 0) {
    return (
      <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', textAlign: 'center' }}>
        <h3>Cargando datos de ventas...</h3>
      </div>
    );
  }

  const totalVentas = salesData.reduce((sum, item) => sum + item.ventas, 0).toFixed(2);
  const totalCantidad = salesData.reduce((sum, item) => sum + item.cantidad, 0);
  const totalMedioPago = methodSales.reduce((sum, item) => sum + item.ventas, 0).toFixed(2);
  const totalTransacciones = methodSales.reduce((sum, item) => sum + item.transacciones, 0);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
        {methodSales.length > 0 && (
          <div style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', marginBottom: '20px' }}>
            <h4 className='text-center'>Resumen de Medios de Pago</h4>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
              {methodSales.map((item, index) => (
                <div key={index} style={{ 
                  flex: '1', 
                  minWidth: '180px', 
                  padding: '10px', 
                  backgroundColor: 'white', 
                  borderRadius: '5px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  borderLeft: `4px solid ${item.color}`
                }}>
                  <h5 style={{ margin: '0 0 5px 0', color: item.color }}>
                    {item.metodo}
                  </h5>
                  <p style={{ margin: '0', fontSize: '14px' }}>
                    <strong>Monto:</strong> S/ {formatCurrency(item.ventas)}
                  </p>
                  <p style={{ margin: '0', fontSize: '14px' }}>
                    <strong>Transacciones:</strong> {item.transacciones}
                  </p>
                  <p style={{ margin: '0', fontSize: '12px', color: '#666' }}>
                    Ranking: #{item.ranking}
                  </p>
                </div>
              ))}
              <div style={{
                flex: '1',
                minWidth: '180px',
                padding: '10px',
                backgroundColor: '#e9ecef',
                borderRadius: '5px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                borderLeft: '4px solid #6c757d'
              }}>
                <h5 style={{ margin: '0 0 5px 0'}}>TOTALES</h5>
                <p><strong>Monto:</strong> S/ {formatCurrency(totalMedioPago)}</p>
                <p><strong>Transacciones:</strong> {totalTransacciones}</p>
              </div>
            </div>
          </div>
        )}

      <div style={{ display: 'flex', width: "100%", marginBottom: '30px', gap: '20px', flexWrap: 'wrap' }}>
        
        <div style={{ flex: '1 1 48%', minWidth: '300px', marginBottom: '30px' }}>
          <h3>Ventas por Medio de Pago</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              data={methodSales}
              layout="vertical"
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis 
                type="number" 
                tickFormatter={(value) => `S/ ${value}`}
              />
              <YAxis type="category" dataKey="metodo" />
              <Tooltip 
                formatter={(value) => [`S/ ${formatCurrency(value)}`, 'Monto Total']}
              />
              <Legend />
              <Bar dataKey="ventas" name="Ventas S/">
                {methodSales.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Gráfico Circular - Medios de Pago */}
        <div style={{ flex: '1 1 48%', minWidth: '300px', marginBottom: '30px' }}>
          <h3>Distribución Porcentual</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={methodSales}
                cx="50%"
                cy="50%"
                outerRadius={80}
                innerRadius={50}
                dataKey="ventas"
                nameKey="metodo"
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(1)}%`}
                labelLine={false}
              >
                {methodSales.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip 
                formatter={(value, name, props) => [
                  
                  `S/ ${formatCurrency(value)} (${props.payload.porcentaje || 0}%)`, 
                  props.payload.metodo
                ]} 
              />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      

      {/* Resumen de ventas por documento */}
      <div style={{ 
        backgroundColor: '#f8f9fa', 
        padding: '15px', 
        borderRadius: '5px',
        marginBottom: '20px'
      }}>
        <h4 className='text-center'>Resumen de Ventas por Documento</h4>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
          {salesData.map((item, index) => (
            <div key={index} style={{ 
              flex: '1', 
              minWidth: '150px', 
              padding: '10px', 
              backgroundColor: 'white', 
              borderRadius: '5px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <h5 style={{ margin: '0 0 5px 0', color: COLORS[index % COLORS.length] }}>
                {item.metodo}
              </h5>
              <p style={{ margin: '0', fontSize: '14px' }}>
                Monto: S/ {item.ventas}
              </p>
              <p style={{ margin: '0', fontSize: '14px' }}>
                Cantidad: {item.cantidad}
              </p>
            </div>
          ))}
          <div style={{
            flex: '1',
            minWidth: '150px',
            padding: '10px',
            backgroundColor: '#e9ecef',
            borderRadius: '5px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <h5 style={{ margin: '0 0 5px 0'}}>TOTALES</h5>
            <p > Monto: S/ {totalVentas}</p>
            <p > Cantidad: {totalCantidad}</p>
          </div>
        </div>
      </div>

      <div style={{ 
        flex: '1 1 100%', 
        marginBottom: '30px' 
      }}>
        <h3>Ventas por Tipo de Documento</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={salesData}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="metodo" />
            <YAxis tickFormatter={(value) => `S/ ${value}`}/>
            <Tooltip 
              formatter={(value, name, props) => {
                if (name === 'ventas') {
                  return [`S/ ${value.toFixed(2)}`, 'Monto'];
                } else {
                  return [value, 'Cantidad'];
                }
              }}
            />
            <Legend />
            <Bar dataKey="ventas" fill="#01a59c" name="Monto (S/)" />
            <Bar dataKey="cantidad" fill="#8884d8" name="Cantidad" />
          </BarChart>
        </ResponsiveContainer>
      </div>


    </div>
  );
};

export default DashboardRecharts;